// Display formatting shared across the storefront and admin.

const inr = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

// formatINR(2499) -> "₹2,499"; formatINR(0, { free: true }) -> "Free"
export const formatINR = (value, { free = false } = {}) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '—';
  if (free && amount === 0) return 'Free';
  return inr.format(amount);
};

const toDate = value => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

// "4 Oct 2026"
export const formatDate = value => {
  const date = toDate(value);
  return date
    ? date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : '—';
};

// "4 Oct 2026, 3:42 pm"
export const formatDateTime = value => {
  const date = toDate(value);
  return date
    ? date.toLocaleString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : '—';
};

export const formatFileSize = megabytes => {
  const mb = Number(megabytes);
  if (!Number.isFinite(mb) || mb <= 0) return null;
  return mb >= 1024 ? `${(mb / 1024).toFixed(1).replace(/\.0$/, '')} GB` : `${Math.round(mb)} MB`;
};
